import { Component, Input } from '@angular/core';
import { TitlePagesComponent } from '../../../../shared/components/title-pages-component/title-pages-component';
import { LegendNivelComponent } from '../../../../shared/components/legend-nivel/legend-nivel';

type PageData = { title: string; subTitle: string };

@Component({
  selector: 'app-reportes-title',
  standalone: true,
  imports: [TitlePagesComponent, LegendNivelComponent],
  templateUrl: './reportes-title.component.html',
  styleUrls: ['./reportes-title.component.scss'],
})
export class ReportesTitleComponent {
  @Input({ required: true }) pageData!: PageData;
}
